import React, { useEffect, useRef, useState } from "react";
import { HotTable } from "@handsontable/react";
import "handsontable/dist/handsontable.min.css";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { contextMenu, firstRowRenderer, sumColumnList } from "../../../components/HandsonTable/handsontable";
import { excelRPT214 } from "../../../Report/200/214/RPT214";
import { duplicateList } from "../../../utilities/arrayListUtil";
import { ZeroToNull } from "../../../utilities/NullUtil";
import { formatDateAPI } from "../../../utilities/DateUtil";

export default function P214List({ dataTable, dataCol, keyListB, searchData, goPage, submitForm }) {
    const hot = useRef(null);
    const history = useHistory();

    const [editRowList, setEditRowList] = useState([]);
    const [columnList, setColumnList] = useState([]);
    const [updateList, setUpdateList] = useState([]);
    const [sumaryBot, setSumaryBot] = useState(0);
    const [readOnlyList, setReadOnlyList] = useState([]);
    const [data, setData] = useState([]);
    const [mergeCells, setMergeCells] = useState([]);

    useEffect(() => {
        //keyListB
        if (dataTable.length > 0 && dataCol.length > 0) {
            HotSetting();
        }
    }, [dataTable, dataCol]);

    const HotSetting = () => {
        let newHdInfo = [
            {
                seqPk: "ที่",
                itemDesc: "รายการ",
                itemUnitDesc: "หน่วย",
                itemUnitPrice: "ราคาต่อหน่วย",
                contractUnit: "สัญญา",
                contractAmount: "",
                accrueUnit: "accrueUnit",
                updateKey: "key",
            },
            {
                seqPk: "",
                itemDesc: "",
                itemUnitDesc: "",
                itemUnitPrice: "",
                contractUnit: "จำนวน",
                contractAmount: "รวม",
                accrueUnit: "accrueUnit",
                updateKey: "key",
            },
        ];
        let newColumnList = ["seqPk", "itemDesc", "itemUnitDesc", "itemUnitPrice", "contractUnit", "contractAmount"];
        let newMergeCells = [
            { row: 0, col: 0, rowspan: 2, colspan: 1 },
            { row: 0, col: 1, rowspan: 2, colspan: 1 },
            { row: 0, col: 2, rowspan: 2, colspan: 1 },
            { row: 0, col: 3, rowspan: 2, colspan: 1 },
            { row: 0, col: 4, rowspan: 1, colspan: 2 },
        ];
        let newDataTable = [...dataTable];
        let newEditRowList = [];
        let SumColList = [];
        let sumaryBot = {
            seqPk: "",
            itemDesc: "TOTAL",
            itemUnitDesc: "",
            itemUnitPrice: "",
            contractUnit: "",
            contractAmount: "",
            accrueUnit: "",
            updateKey: "",
        };

        let sumaryRead = [];
        let conutMerge = 6;

        let newReadOnlyList = dataTable.map(() => []);
        newReadOnlyList.push([]);

        dataCol.forEach((obj) => {
            // const findIndex = dataTable.findIndex((item) => {
            //     return item.seqPk === obj.seqPk;
            // });

            const findIndex = (obj.seqPk - 1) % dataTable.length;
            // console.log("🚀 ~ file: P214List.js ~ line 93 ~ dataCol.forEach ~ findIndex", findIndex)

            if (findIndex > -1) {
                let newData = newDataTable[findIndex];

                if (obj.inputFlag === "Y") {
                    SumColList.push(conutMerge - 2);
                    SumColList = duplicateList(SumColList);
                }

                if (findIndex === 0) {
                    newColumnList.push(`columnUnit_${obj.columnNo}`);
                    newColumnList.push(`columnAmount_${obj.columnNo}`);
                    //Start Col - 8 AF.+2
                    newMergeCells.push({ row: 0, col: conutMerge, rowspan: 1, colspan: 2 });
                    newEditRowList.push(conutMerge);
                    conutMerge += 2;

                    sumaryRead.push("N");
                    sumaryRead.push("N");

                    let newColHd = {
                        ...newHdInfo[0],
                        [`columnUnit_${obj.columnNo}`]: obj.columnHeader,
                        [`columnAmount_${obj.columnNo}`]: "",
                    };
                    newHdInfo[0] = newColHd;

                    newColHd = {
                        ...newHdInfo[1],
                        [`columnUnit_${obj.columnNo}`]: "จำนวน",
                        [`columnAmount_${obj.columnNo}`]: "รวม",
                    };
                    newHdInfo[1] = newColHd;

                    sumaryBot = {
                        ...sumaryBot,
                        [`columnUnit_${obj.routeNo}`]: "",
                        [`columnAmount_${obj.routeNo}`]: "",
                    };
                }

                newReadOnlyList[newData.seqPk].push(obj.inputFlag);
                newReadOnlyList[newData.seqPk].push("N");

                newData = {
                    ...newData,
                    [`columnNo_${obj.columnNo}`]: obj.columnNo,
                    [`columnUnit_${obj.columnNo}`]: ZeroToNull(obj.columnUnit),
                    [`columnAmount_${obj.columnNo}`]: ZeroToNull(obj.columnAmount),
                };

                newDataTable[findIndex] = newData;
            }
        });

        SumColList.forEach((item) => {
            let sum = sumColumnList(newDataTable, newColumnList[item]);
            let all = sumColumnList(newDataTable, newColumnList[item + 1]);

            sumaryBot = {
                ...sumaryBot,
                [`${newColumnList[item]}`]: sum,
                [`${newColumnList[item + 1]}`]: all,
            };
        });

        newDataTable.push(sumaryBot);
        newReadOnlyList.push(sumaryRead);
        setSumaryBot(newDataTable.length + 2);

        setData([...newHdInfo, ...newDataTable]);
        setColumnList(newColumnList);
        setMergeCells(newMergeCells);
        setReadOnlyList(newReadOnlyList);
        newEditRowList.pop();
        setEditRowList(newEditRowList);
    };

    const rendercolumns = () => {
        let columnData = [];
        columnList.forEach((item, index) => {
            if (index > 2) {
                columnData.push({
                    data: item,
                    type: "numeric",
                    numericFormat: {
                        pattern: "0,0",
                    },
                });
            } else {
                columnData.push({ data: item });
            }
        });
        return columnData;
    };

    const onAfterChange = (changes, source) => {
        if (!changes) {
            return;
        }

        //changes val
        let row = changes[0][0];
        let col = changes[0][1]; // Check to columnList index
        let oldVal = changes[0][2] === null || changes[0][2] === "" ? 0 : parseInt(changes[0][2]);
        let newVal = changes[0][3] === null || changes[0][3] === "" ? 0 : parseInt(changes[0][3]);
        let indexCol = columnList.findIndex((item) => item === col);

        if (editRowList.findIndex((item) => item === indexCol) > -1) {
            // KeyUpdate from keyListB
            let key = keyListB[row];

            //Get ref From HotTable
            let hotdata = hot.current.hotInstance;

            let indexUnitPrice = columnList.findIndex((item) => item === "itemUnitPrice");

            if (indexCol > -1) {
                let itemUnitPrice = hotdata.getDataAtCell(row, indexUnitPrice);

                let newAmountVal = newVal * itemUnitPrice;

                // let routeAmount = hotdata.getDataAtCell(row,indexCol+1);
                hotdata.setDataAtCell(row, indexCol + 1, newAmountVal);

                // 06/03/2022
                if (newAmountVal !== 0) onUpdateList(newVal, key);
                // if (newAmountVal !== 0) onUpdateList(newAmountVal, key);
            }
        }
    };

    const onUpdateList = (newVal, key) => {
        /** setUpdate Data */
        // let columnNo = col.replace('columnUnit_','')
        let newUpdateList = [...updateList];
        newUpdateList.push({
            userId: searchData.userId,
            contractNo: searchData.contractNo,
            routeNo: searchData.routeNo,
            // routeUnit: newVal,
            resultUnit: newVal,
            updateKey: key,
            //  06/03/2022
            resultDate: formatDateAPI(new Date(), false),
        });

        setUpdateList(newUpdateList);
    };

    const columnSummary = () => {
        if (hot.current && hot.current !== null) {
            let hotTable = hot.current.hotInstance;
            let sumRow = hotTable.countRows() - 1;

            let colSummaryArr = [];
            let countCols = hotTable.countCols();
            if (countCols > 0) {
                // sum would be for column 3 onwards
                for (let i = 2; i < countCols; i++) {
                    colSummaryArr.push({
                        destinationRow: sumRow,
                        destinationColumn: i,
                        // reversedRowCoords: true,
                        type: "sum",
                        ranges: [[2, sumRow - 1]],
                    });
                }
                return colSummaryArr;
            } else {
                return [];
            }
        } else {
            return [];
        }
    };

    const cells = (row, col) => {
        const cellProperties = {};
        /**
         * Set Coloer Table
         */
        if (row === 0 || row === 1) {
            cellProperties.renderer = firstRowRenderer; //Header Table
        }
        // else{
        //     cellProperties.renderer = percentRenderer;
        // }

        if (row > 1) {
            if (col === 0 || col === 2) {
                cellProperties.className = " detail_center";
            } else {
                cellProperties.className = " detail";
            }
        }

        cellProperties.readOnly = true;
        // row -newReadOnlyList 1 == 2 row hot
        // col -newReadOnlyList 0 == 6 col hot

        if (row > 1 && col > 5) {
            if (readOnlyList && readOnlyList.length > 0 && row - 1 >= 0 && col - 6 >= 0) {
                if (readOnlyList[row - 1][col - 6] && readOnlyList[row - 1][col - 6] === "Y") {
                    cellProperties.readOnly = false;
                    cellProperties.className = " detail_input";
                }
            }
        }

        if (row === sumaryBot - 1) {
            cellProperties.readOnly = true;
            cellProperties.className = " summary_bot";
        }

        return cellProperties;
    };

    const onExport = () => {
        // console.log(act);
        excelRPT214(data); //, setLoading, toast
    };

    return (
        <div>
            {dataTable && dataTable.length > 0 ? (
                <>
                    {data.length > 0 ? (
                        <HotTable
                            ref={hot}
                            data={data}
                            columns={rendercolumns()}
                            mergeCells={mergeCells}
                            autoRowSize={false}
                            autoColumnSize={true}
                            height={data.length > 50 ? "600px" : "300px"}
                            contextMenu={contextMenu}
                            colWidths={[50, 400]}
                            cells={(row, col) => cells(row, col)}
                            afterChange={(changes, source) => onAfterChange(changes, source)}
                            columnSummary={columnSummary}
                        />
                    ) : (
                        "Load Data .."
                    )}
                </>
            ) : (
                "No Data"
            )}

            <div className="p-col-12 p-md-12">
                <div className="p-grid" style={{ textAlign: "center", marginTop: 20 }}>
                    <div className="p-col-12">
                        {/* <Button className="p-button-success p-button btn-srh-responsive" icon="pi pi-save" label="บันทึก" disabled={!(dataTable && dataTable.length > 0)} style={{ width: 120, marginLeft: "5px", marginTop: "10px" }} onClick={() => submitForm(updateList, 215)} /> */}
                        <Button className="p-button-success p-button btn-srh-responsive" icon="pi pi-save" label="บันทึก" disabled={!(dataTable && dataTable.length > 0)} style={{ width: 120, marginLeft: "5px", marginTop: "10px" }} onClick={() => submitForm(updateList, 214)} />
                        <Button className="p-button-secondary p-button btn-long-responsive" icon="pi pi-arrow-left" label="กลับหน้าจอแสดงรายการ" disabled={!(dataTable && dataTable.length > 0)} style={{ width: 250, marginLeft: "5px", marginTop: "10px" }} onClick={() => history.push("/208")} />
                        <Button className="p-button-excel p-button btn-long-responsive" icon="fa fa-file-excel" label="Export Excel" disabled={!(dataTable && dataTable.length > 0)} style={{ width: 250, marginLeft: "5px", marginTop: "10px" }} onClick={() => onExport()} />
                    </div>
                </div>
            </div>
        </div>
    );
}
